import { render, staticRenderFns } from "./investmentTask.vue?vue&type=template&id=b2a4f910&scoped=true&"
import script from "./investmentTask.vue?vue&type=script&lang=js&"
export * from "./investmentTask.vue?vue&type=script&lang=js&"
import style0 from "./investmentTask.vue?vue&type=style&index=0&id=b2a4f910&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a4f910",
  null
  
)

export default component.exports